import React from 'react';
import loadable from '@loadable/component';
import Marquee from 'react-double-marquee';
import NoticesSlickSlider from "../../components/NoticesSlickSlider";
var WeducNotices = loadable(function () {
  return import('@accrosoft-ltd/accropress-websites-components/dist/esm/weducNotices');
});

var WeducNoticesComp = function WeducNoticesComp(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.config.noticesType === "popup" ? /*#__PURE__*/React.createElement("div", {
    id: "weduc_notices_home_announcements_panel_wrapper",
    className: "banner-inner weducWidgetDisplay_" + props.noticesMainLoaded
  }, props.toggled && /*#__PURE__*/React.createElement("div", {
    id: "weduc_notices_home_announcements_panel_wrapper__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "weduc_notices_home_announcements_panel_wrapper__content__openclose",
    onClick: function onClick() {
      return props.setToggled(false);
    }
  }, /*#__PURE__*/React.createElement("span", null, "X")), /*#__PURE__*/React.createElement(NoticesSlickSlider, {
    config: props.config,
    setNoticesMainLoaded: props.setNoticesMainLoaded,
    noticesMainLoaded: props.noticesMainLoaded
  })), /*#__PURE__*/React.createElement("div", {
    id: "weduc_notices_home_announcements_panel_wrapper__bell",
    onClick: function onClick() {
      return props.setToggled(true);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "icon"
  }, /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "30px",
    viewBox: "0 0 50 30",
    enableBackground: "new 0 0 50 30"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bell-icon__group"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bell-icon__ball",
    id: "ball",
    fillRule: "evenodd",
    strokeWidth: "1.5",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#currentColor",
    strokeMiterlimit: "10",
    d: "M28.7,25 c0,1.9-1.7,3.5-3.7,3.5s-3.7-1.6-3.7-3.5s1.7-3.5,3.7-3.5S28.7,23,28.7,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bell-icon__shell",
    id: "shell",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    stroke: "#currentColor",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    d: "M35.9,21.8c-1.2-0.7-4.1-3-3.4-8.7c0.1-1,0.1-2.1,0-3.1h0c-0.3-4.1-3.9-7.2-8.1-6.9c-3.7,0.3-6.6,3.2-6.9,6.9h0 c-0.1,1-0.1,2.1,0,3.1c0.6,5.7-2.2,8-3.4,8.7c-0.4,0.2-0.6,0.6-0.6,1v1.8c0,0.2,0.2,0.4,0.4,0.4h22.2c0.2,0,0.4-0.2,0.4-0.4v-1.8 C36.5,22.4,36.3,22,35.9,21.8L35.9,21.8z"
  })))))) : props.config.noticesType === "static" ? /*#__PURE__*/React.createElement("div", {
    className: "banner-inner weducWidgetDisplay_" + props.noticesMainLoaded
  }, /*#__PURE__*/React.createElement("div", {
    className: props.toggled ? 'close-alert' : 'open'
  }, /*#__PURE__*/React.createElement("div", {
    className: "bannerTextClose"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return props.setToggled(true);
    }
  }, /*#__PURE__*/React.createElement("span", null, props.noticesBannerExpanded ? '' : ''))), /*#__PURE__*/React.createElement("div", {
    className: "bannerText"
  }, /*#__PURE__*/React.createElement(WeducNotices, {
    delay: 5,
    limit: 1,
    name: props.config.weducWebsitesID,
    container: props.config.weducEntityID,
    html: props.NoticeTemplate,
    loadedEvent: props.setNoticesMainLoaded
  })))) : /*#__PURE__*/React.createElement(Marquee, {
    speed: -0.1
  }, /*#__PURE__*/React.createElement(WeducNotices, {
    delay: 5,
    limit: 5,
    name: props.config.weducWebsitesID,
    container: props.config.weducEntityID,
    html: props.NoticeTemplate,
    loaded: props.noticesMainLoaded,
    loadedEvent: props.setNoticesMainLoaded
  })));
};

export default WeducNoticesComp;